<template>
  <div class="overflow-y-scroll scrolling-touch">
    <button class="popover-item" @click="goTo(user)" v-for="user in users" :key="user.id">
      <span class="p-2 mr-2 text-gray bg-gray-darkest rounded-full inline-flex items-center">
        <svgicon name="user-a-solid"/>
      </span>
      <span class="inline-flex flex-col">
        <span class="uppercase tracking-wide text-xs">{{ user.display_name }}</span>
        <small class="text-gray">{{ user.role.label }}</small>
      </span>
    </button>
  </div>
</template>

<script>
/* globals axios route */

import ErrorHandler from '../../core/ErrorHandler';

export default {
  props: [],

  data() {
    return {
      users: [],
    };
  },

  created() {
    axios
      .get(route('api.users.index'))
      .then(({ data }) => {
        this.users = data.data;
      })
      .catch(error => new ErrorHandler(error).dispatch());
  },

  methods: {
    goTo(user) {
      window.location.href = `${route('lock')}?user=${user.id}`;
    },
  },
};
</script>

<style scoped lang="scss">
.overflow-y-scroll {
  max-height: 200px;
}
</style>
